export default __webpack_public_path__ + "static/media/bank.4f21bca7.svg";